/**
 * Placeholder for common functionality used across sportsbook.
 *
 * @module common
 */

import Polyfills from './common/Polyfills';
    
    Polyfills.init();
    export default window.WH.messageBus;
